<script>
import { mapActions, mapState } from "vuex";
import { formatHashrate, formatRelativeDate } from "@/utils";

export default {
  props: {
    contractId: {
      default: null,
    },
  },

  data() {
    return {
      contract: null,
      loading: false,
      teamWorkers: {},
    };
  },

  computed: {
    // Mapped state
    ...mapState(["workerShares"]),
  },

  async created() {
    this.loading = true;
    this.contract = await this.getContract({ contractId: this.contractId });
    this.teamWorkers = await this.getWorkersForTeam({
      contractId: this.contractId,
      teamId: this.contract.team.id,
    });
    this.loading = false;
  },

  methods: {
    // Redirect to a selected worker
    goToWorker(worker) {
      this.$router.push(`/workers/${worker.id}`);
    },

    // Helper methods and mapped actions
    formatHashrate,
    formatRelativeDate,
    ...mapActions(["getContract", "getWorker", "getWorkersForTeam"]),
  },
};
</script>

<template>
  <div class="Group-workers">
    <b-row class="mb-3">
      <b-col>
        <h3>Contract Workers</h3>
      </b-col>
    </b-row>
    <b-row v-if="!loading">
      <b-col v-if="!contract.worker_ids || contract.worker_ids.length === 0">
        <b-card class="text-center py-5" key="no-workers">
          <b-card-title>No Workers</b-card-title>
          <b-card-text>There are no workers in this contract.</b-card-text>
        </b-card>
      </b-col>
      <b-col v-else>
        <b-table-simple striped hover responsive>
          <b-thead>
            <b-tr>
              <b-th>Name</b-th>
              <b-th>Device</b-th>
              <b-th>Hashrate</b-th>
              <b-th>Last Submission</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(worker_id, index) in contract.worker_ids"
              :key="index"
            >
              <b-td>
                <b-link :to="`/workers/${worker_id}`">
                  {{ teamWorkers[worker_id].name }}
                </b-link>
              </b-td>
              <b-td>{{ teamWorkers[worker_id].device.name }}</b-td>
              <b-td>{{ formatHashrate(teamWorkers[worker_id].hashrate) }}</b-td>
              <b-td>
                {{ formatRelativeDate(teamWorkers[worker_id].last_submitted) }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col class="text-center mt-5">
        <div class="mb-4">
          <b-spinner
            style="width: 4rem; height: 4rem"
            variant="primary"
            label="Loading Contract..."
          ></b-spinner>
        </div>
        <b>Loading Contract...</b>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
#dt-show-more:hover {
  cursor: pointer;
}
</style>
